import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import TableKeys from '../components/Table/ConfigurationTable'
import { StyledContainer } from '../styled'
import { DriverKeyTableHead } from '../components/Table/data'

const ConfigurationDriver = ({
  fetchData,
  success,
  pageLimitChanged,
  pageChanged,
  onCloseReset,
  isLoadingDriverList,
  drivers,
  driverCount,
  searchData,
  errorMessage,
  removeError,
  isErrorFetch,
  isSuccessRefresh,
  resetSuccessAction,
}) => {
  useEffect(() => {
    fetchData()
  }, [])
  useEffect(() => {
    if (success && isSuccessRefresh) {
      fetchData()
    }
    if (success || isSuccessRefresh) {
      resetSuccessAction()
    }
  }, [success])

  return (
    <StyledContainer>
      <TableKeys
        globalID={'DriverKeys'}
        searchData={searchData}
        searchPlaceholder={'Rechercher par chauffeur'}
        tableHead={DriverKeyTableHead}
        tableRows={drivers}
        isDriverKey={true}
        actionButton={true}
        title={'Association Clés-Chauffeur'}
        loadingData={isLoadingDriverList}
        pageLimitChanged={pageLimitChanged}
        pageChanged={pageChanged}
        onCloseReset={onCloseReset}
        countData={driverCount}
        errorMessage={errorMessage}
        removeError={removeError}
        isErrorFetch={isErrorFetch}
        fetchData={fetchData}
        resetPagination={success && isSuccessRefresh}
      />
    </StyledContainer>
  )
}
ConfigurationDriver.propTypes = {
  drivers: PropTypes.array,
  fetchData: PropTypes.func,
  isLoadingDriverList: PropTypes.bool,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  searchKeys: PropTypes.func,
  onCloseReset: PropTypes.func,
  searchData: PropTypes.func,
  success: PropTypes.bool,
  driverCount: PropTypes.number,
  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
}
export default ConfigurationDriver
